import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/layout';

import { menuRightsStorage } from '@/storages/localStorage';

import { userInfoStorage } from '@/storages/sessionStorage';

import getAllRouterList from '@/framework/router/getAllRouterList';

import filterTreeSave from 'evenlea-utils/array/filterTreeSave';
import expandPermissionRights from '@/framework/router/expandPermissionRights';

let trueModules = getAllRouterList();

let blackList = menuRightsStorage.get() || [];
blackList = expandPermissionRights(blackList, trueModules);

let userInfoVal = userInfoStorage.get();

// 要有这个值，说明登录了
if (userInfoVal) {
  // 并且不是超级管理员
  if (!userInfoVal.isSuperAdmin) {
    trueModules = filterTreeSave(blackList, getAllRouterList());
  }
} else {
  // 不处理，开放所有权限，但是让路由拦截到登录页面
}

console.log(trueModules);

Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

let constantRoutes = [
  ...trueModules,

  {
    path: '/',
    redirect: '/home/first',
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
    hidden: true,
  },
  {
    path: '/wecom-session',
    name: 'wecomSession',
    component: () => import('@/views/wecomSession'),
    hidden: true,
  },

  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },

  // {
  //   path: 'external-link',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'https://element.eleme.cn',
  //       meta: { title: 'External Link', icon: 'link' },
  //     },
  //   ],
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () => {
  return new Router({
    routes: constantRoutes,
    scrollBehavior: () => ({ y: 0 }),
  });
};

const routerInstance = createRouter();

// 更新路由的新方案，貌似现在不需要用动态路由了
// // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// export function resetRouter() {
//   const newRouter = createRouter()
//   routerInstance.matcher = newRouter.matcher // reset router
// }

export default routerInstance;
